import React from "react";
import { ProgressBar } from "react-bootstrap";
import { Skeleton } from "@material-ui/lab";

export const ProgressCustomerCare = (props) => (
  <>
    <div className="row">
      <div className="col-lg-6 col-sm-12">
        <h6 className="col-12 pl-7">CHIAMATE:</h6>
        <div className="col-12 p-7">
          <label className="col-12">
            Settimanale
            {props.callsProgressBar.weekCalls !== undefined
              ? ": " +
                props.callsProgressBar.weekCalls +
                "/" +
                props.callsProgressBar.obiettivoSettimanale
              : ": 0/0"}
          </label>
          {!props.loading && props.selectedUser ? (
            <ProgressBar
              animated
              variant="success"
              now={
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageWeek !== undefined
                  ? props.callsProgressBar.percentageWeek
                  : 0
              }
              label={`${
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageWeek !== undefined
                  ? props.callsProgressBar.percentageWeek
                  : 0
              }%`}
            />
          ) : (
            <Skeleton />
          )}
        </div>
        <div className="col-12 p-7">
          <label className="col-12">
            Mensile
            {props.callsProgressBar.monthCalls !== undefined
              ? ": " +
                props.callsProgressBar.monthCalls +
                "/" +
                props.callsProgressBar.obiettivoMensile
              : ": 0/0"}
          </label>
          {!props.loading && props.selectedUser ? (
            <ProgressBar
              animated
              variant="info"
              now={
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageMonth !== undefined
                  ? props.callsProgressBar.percentageMonth
                  : 0
              }
              label={`${
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageMonth !== undefined
                  ? props.callsProgressBar.percentageMonth
                  : 0
              }%`}
            />
          ) : (
            <Skeleton />
          )}
        </div>
      </div>
      <div className="col-lg-6 col-sm-12">
        <h6 className="col-12 pl-7">ORE PRODUTTIVITÀ:</h6>
        <div className="col-12 p-7">
          <label className="col-12">Settimanale</label>
          {!props.loading && props.selectedUser ? (
            <ProgressBar
              animated
              variant="success"
              now={
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageDurationWeek !== undefined
                  ? props.callsProgressBar.percentageDurationWeek
                  : 0
              }
              label={`${
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageDurationWeek !== undefined
                  ? props.callsProgressBar.percentageDurationWeek
                  : 0
              }%`}
            />
          ) : (
            <Skeleton />
          )}
        </div>
        <div className="col-12 p-7">
          <label className="col-12">Mensile</label>
          {!props.loading && props.selectedUser ? (
            <ProgressBar
              animated
              variant="info"
              now={
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageDurationMonth !== undefined
                  ? props.callsProgressBar.percentageDurationMonth
                  : 0
              }
              label={`${
                props.callsProgressBar !== undefined &&
                props.callsProgressBar.percentageDurationMonth !== undefined
                  ? props.callsProgressBar.percentageDurationMonth
                  : 0
              }%`}
            />
          ) : (
            <Skeleton />
          )}
        </div>
      </div>
    </div>
  </>
);
